"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ActionButtons_1 = __importDefault(require("../../ActionButtons"));
var Button_1 = __importDefault(require("../../Button"));
var CardQuestion_1 = __importDefault(require("../CardQuestion"));
var CardAnswer_1 = __importDefault(require("../CardAnswer"));
var CardPreview = function (_a) {
    var card = _a.card, other = __rest(_a, ["card"]);
    var _b = __read(react_1.useState('question'), 2), view = _b[0], setView = _b[1];
    var _c = __read(react_1.useState(false), 2), showSummary = _c[0], setShowSummary = _c[1];
    var _d = __read(react_1.useState(false), 2), showExplanation = _d[0], setShowExplanation = _d[1];
    function toggleView() {
        setView(view === 'question' ? 'answer' : 'question');
    }
    return (react_1.default.createElement("div", __assign({}, other),
        react_1.default.createElement(ActionButtons_1.default, { align: "center", marginBottom: true },
            react_1.default.createElement(Button_1.default, { size: "large", variant: "text", color: "primary", onClick: toggleView }, view === 'question' ? 'Show answer' : 'Show question')),
        view === 'question' && card.question && (react_1.default.createElement(CardQuestion_1.default, { card: card, showSummary: showSummary, onClickShowSummary: function () { return setShowSummary(true); } })),
        view === 'answer' && card.answer && (react_1.default.createElement(CardAnswer_1.default, { card: card, showExplanation: showExplanation, onClickShowExplanation: function () { return setShowExplanation(true); } }))));
};
exports.default = CardPreview;
//# sourceMappingURL=CardPreview.js.map